import { Box, Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"

const useStyles = makeStyles()((theme) => ({
    legend: {
        padding: ".75rem .25rem 0",
        flexWrap: "wrap",
    },
    item: {
        color: theme.palette.tailwind.slate[600],
    },
    swatch: {
        width: "1.5rem",
        height: "1.5rem",
        borderRadius: ".25rem",
        border: `1px solid ${theme.palette.tailwind.slate[200]}`,
        flexShrink: 0,
    },
    swatchEmpty: {
        background: theme.palette.common.white,
    },
    swatchFilled: {
        background: theme.palette.tailwind.green[100],
    },
    swatchNeedsFill: {
        background: theme.palette.tailwind.amber[100],
    },
    swatchDefault: {
        background: theme.palette.tailwind.blue[100],
    },
    swatchAiMode: {
        background: theme.palette.tailwind.purple[200],
    },
}))

export function WeekMenuLegend() {
    const { classes, cx } = useStyles()

    const items = [
        { id: "merchant-week-menu-legend-empty", swatch: classes.swatchEmpty, fallback: "Empty" },
        { id: "merchant-week-menu-legend-filled", swatch: classes.swatchFilled, fallback: "Filled (complete)" },
        {
            id: "merchant-week-menu-legend-needs-fill",
            swatch: classes.swatchNeedsFill,
            fallback: "Started, required field missing",
        },
        {
            id: "merchant-week-menu-legend-default",
            swatch: classes.swatchDefault,
            fallback: "Template default — editable, not yet edited",
        },
        { id: "merchant-week-menu-legend-ai-mode", swatch: classes.swatchAiMode, fallback: "AI mode" },
    ] as const

    return (
        <Stack direction="row" spacing="2rem" className={classes.legend}>
            {items.map((item) => (
                <Stack key={item.id} direction="row" alignItems="center" spacing=".5rem">
                    <Box className={cx(classes.swatch, item.swatch)} />
                    <LocalizedStrict id={item.id}>
                        <Typography variant="body2" className={classes.item}>
                            {item.fallback}
                        </Typography>
                    </LocalizedStrict>
                </Stack>
            ))}
        </Stack>
    )
}
